import type { WidgetType } from '@/types/dashboard';

export const DEFAULT_PANEL_SIZES: Record<WidgetType, { w: number; h: number }> = {
  indicator:    { w: 2, h: 1 },
  labeled_list: { w: 4, h: 3 },
  chart:        { w: 6, h: 4 },
  chat:         { w: 3, h: 2 },
  entity_list:  { w: 8, h: 15 },
};

export function getDefaultPanelSize(type: WidgetType): { w: number; h: number } {
  return DEFAULT_PANEL_SIZES[type];
}
